<template>
  <div class="tx-dealersearch module-search-result" :class="{'-clicked': clicked}">
    <a class="result__link" :href="result.website" target="_blank">
      <div class="result__headline">
        <div class="headline__title">
          <span class="heading epsilon">{{ result.name }}</span>
        </div>
      </div>
      <div class="result__address">
        <span v-if="result.contactPerson">{{ result.contactPerson }}</span><br v-if="result.contactPerson">
        <span>{{ result.street }}</span><br>
        <span>{{ result.zip }} {{ result.city }}</span><br>
      </div>
    </a>
    <div class="result__actions">
      <div class="actions__wrapper">
        <div class="action__route">
          <a :href="`https://maps.google.de/?saddr=&daddr=${result.street}, ${result.zip} ${result.city}, ${result.name}`" target="_blank" class="btn -btn-accent icon-location-before"><span>{{ $t('dealersearch.result.route') }}</span></a>
        </div>
        <div class="action__phone" v-if="result.phone">
          <a :href="`tel:${result.phone}`" class="btn -btn-accent-inverted icon-phone-before" @click="handleTelLink"><span v-if="!showTel">{{ $t('dealersearch.result.phone') }}</span><span v-else>{{ result.phone }}</span></a>
        </div>
        <div class="action__email" v-if="result.email">
          <a :href="`mailto:${result.email}`" class="btn -btn-accent-inverted icon-email-before"><span>{{ $t('dealersearch.result.email') }}</span></a>
        </div>
      </div>
      <div class="action__link" v-if="result.website">
        <a  class="link" :href="result.website" target="_blank"><span>{{ $t('dealersearch.result.moreInfo') }}</span></a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SearchResult',
  inject: ['phone'],
  data () {
    return {
      showTel: false
    }
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    clicked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleTelLink (event) {
      if (!this.phone) {
        event.preventDefault()
        this.showTel = !this.showTel
      }
    }
  }
}
</script>
